var map = {
	"./vilaverde/default-logo.png": 9501,
	"./vilaverde/favicon.png": 15074,
	"./vilaverde/footer-logo.png": 71169,
	"./vilaverde/logo-1.svg": 95380,
	"./vilaverde/logo-2.svg": 43591,
	"./vilaverde/logo-3.svg": 79766,
	"./vilaverde/logo-header-mobile.svg": 29051,
	"./vilaverde/logo-header-tablet.svg": 72829,
	"./vilaverde/logo-header.svg": 45336,
	"./vilaverde/logo-mobile.svg": 79533,
	"./vilaverde/logo.svg": 67438,
	"./vilaverde/maskable-icon.png": 78208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68869;